import { PropsWithChildren } from "react";
import {
  WINDOW_SIZES,
  WindowSize,
} from "../../context/window-dimensions-context/WindowDimensions.Parts";

// TEXT

// STYLES

// DATA

// TYPES
export type SizeProps = { [K in WindowSize]?: boolean };
export type SizeAliasProps = { mobile?: boolean; desktop?: boolean };

export type Props = PropsWithChildren<SizeProps & SizeAliasProps>;

// CONSTANTS

// FUNCTIONS

/**
 * Extracts valid window sizes from props where the value is true.
 *
 * @param props - DisplayOn component props
 * @returns Array of window sizes where the prop is true
 */
export const getSizesFromProps = (props: Props): WindowSize[] => {
  const sizes = Object.entries(props)
    .filter(([k, v]) => Boolean(v) && WINDOW_SIZES.includes(k as never))
    .map(([key]) => key as WindowSize);

  if (props.mobile) sizes.push("small");
  if (props.desktop) sizes.push("medium", "large", "xlarge");

  return Array.from(new Set(sizes));
};

// ASSETS
